import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { LanguageProvider } from '@i18n'
import '@digdir/designsystemet-web'
import '@digdir/designsystemet-css'
import '@digdir/designsystemet-css/theme'
import '@sdir/sds/lib/components/index.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </React.StrictMode>,
)
